import type { FC } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { Button } from '@/components/Button/Button';
import { routes } from '@/constants';
import { contactsPageObject } from '@/utils';
import { ContactsList } from './components/ContactsList/ContactsList';
import type { ContactsPageProps } from './ContactsPage.types';
import styles from './ContactsPage.module.scss';
export const ContactsPage: FC<ContactsPageProps> = ({
  contacts
}) => {
  const {
    t
  } = useTranslation('contacts');
  return <div {...contactsPageObject.nodeProps} className={styles.root} data-sentry-component="ContactsPage" data-sentry-source-file="ContactsPage.tsx">
      <div className={styles.header}>
        <h1 className={styles.title}>{t('title', 'Contacts')}</h1>
      </div>
      <div className={styles.container}>
        <ContactsList contacts={contacts} data-sentry-element="ContactsList" data-sentry-source-file="ContactsPage.tsx" />
        <h2 className={styles.subtitle}>
          <Trans i18nKey="links.support.faq.text" ns="contacts" components={[<Button {...contactsPageObject.faq.nodeProps} as="link" className={styles.link} variant="text" href={routes.faq} key="links.support.faq.text" />]} data-sentry-element="Trans" data-sentry-source-file="ContactsPage.tsx">
            {`Find the answer to your question in the <0>faq</0>`}
          </Trans>
        </h2>
      </div>
    </div>;
};